import type { AppConfig } from '../types/app-config-type.ts';

export function formatOrderId(config: AppConfig, id: string): string {
    const { stripOrderIdPrefix } = config;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- guaranteed to have at least one element
    return stripOrderIdPrefix ? id.split('-').at(-1)! : id;
}
